module.exports = __webpack_public_path__ + "img/tianjinlogo.b967fbd2.png";